<div class="text">Registrations</div>
<div class="text">Quality Acquisitions</div>
<div class="text">K2L</div>
<div><div class="box" [ngClass]="values.registrations.color">{{ values.registrations.value }}</div></div>
<div><div class="box" [ngClass]="values.quality.color">{{ values.quality.value }}%</div></div>
<div><div class="box" [ngClass]="values.k2l.color">{{ values.k2l.value }}</div></div>